// (function Showpic1() {
// 	document.getElementById("image").src = "/sites/default/files/2024-06/disaster-chopper_v2.jpg";
// })();

// (function Showpic2() {
// 	document.getElementById("image").src = "/sites/default/files/2024-05/mimosa-receiver.jpeg";
// })();

(function ($, Drupal) {

	'use strict';

	// Sticky main navbar when scrolled.
	$(window).on('scroll', function () {
		if ($(this).scrollTop() > 25) {
			$('.navbar').addClass('navbar-scrolled');
		}
		else {
			$('.navbar').removeClass('navbar-scrolled');
		}
	});

	// End sticky main navbar when scrolled.


	// Make submenu full browser width.
	$(window).on('load resize', function () {
		submenuFullwidthCalc();
	});

	const submenuFullwidthCalc = function () {

		// Get the Mega menu Level 1 sub menu.
		$('.tb-megamenu-nav > .level-1 > .tb-megamenu-submenu').each(function () {

			// Reset to zero so it can be calculated again and again.
			$(this).css('left', 0);

			const offsettarget = $('body').offset();

			// The offset of this submenu.
			const offsetthis = $(this)
				.parent()
				.offset();

			// Calculate the offset.
			$(this).css('left', offsettarget.left - offsetthis.left);

			// Set the submenu full width.
			$(this).css('width', $('body').width());
		});
	};

	// End Make submenu full browser width.


	$(document).ready(function () {


		// ============================================================
		// Video transcript toggle.
		// ============================================================

		$('.video-transcript__toggle').on('click', function () {

			const $button = $(this);
			const $transcript = $button.siblings('.video-transcript__content');

			// Make sure we found the transcript.
			if (!$transcript.length) {
				return;
			}

			if ($transcript.hasClass('expanded')) {

				// Collapse.
				$transcript
					.css('max-height', '180px')
					.removeClass('expanded');

				$button
					.text('Show more')
					.attr('aria-expanded', 'false');

			}
			else {

				// Get the actual height of the content.
				const fullHeight = $transcript[0].scrollHeight;

				// Expand to the actual content height.
				$transcript
					.css('max-height', fullHeight + 'px')
					.addClass('expanded');

				$button
					.text('Show less')
					.attr('aria-expanded', 'true');
			}

		});

		// ============================================================
		// End Video transcript toggle.
		// ============================================================

		// ============================================================
		// Multi-item carousels (show 3, advance 1).
		// ============================================================

		$('.my-product-carousel').each(function () {

			const carousel = this;

			const track = carousel.querySelector('.my-carousel-track');
			const cards = carousel.querySelectorAll('.my-carousel-card');
			const prev = carousel.querySelector('.my-carousel-prev');
			const next = carousel.querySelector('.my-carousel-next');

			let current = 0;

			function getVisible() {
				if (window.innerWidth <= 575) {
					return 1;
				}

				if (window.innerWidth <= 767) {
					return 2;
				}

				return 3;
			}

			function update() {
				const visible = getVisible();
				const max = Math.max(0, cards.length - visible);

				if (current > max) {
					current = max;
				}

				const amount = (100 / visible) * current;

				track.style.transform = 'translateX(-' + amount + '%)';

				prev.disabled = current === 0;
				next.disabled = current === max;
			}

			next.addEventListener('click', function () {
				const visible = getVisible();
				const max = Math.max(0, cards.length - visible);

				if (current < max) {
					current++;
					update();
				}
			});

			prev.addEventListener('click', function () {
				if (current > 0) {
					current--;
					update();
				}
			});

			$(window).on('resize', update);

			update();

		});

		// ============================================================
		// End multi-item carousels.
		// ============================================================


		// ============================================================
		// Copy link code (Video page).
		// ============================================================

		$('.share-copy').on('click', function () {

			const $button = $(this);
			const url = $button.data('url');

			if (navigator.clipboard && url) {
				navigator.clipboard.writeText(url);
			}

			$button.html('<span class="icon-checkmark"></span>');

			setTimeout(function () {
				$button.html('<span class="icon-link"></span>');
			}, 1500);

		});

		// ============================================================
		// End Copy link code.
		// ============================================================



		// ============================================================
		// Accordion custom images.
		// ============================================================

		$('.accordion-header').on('click', function () {

			const target = $(this).attr('id');

			if (!target) {
				return;
			}

			const id = target.slice(-3);

			$('.custom-images div').addClass('d-none');
			$('#img_' + id).removeClass('d-none');

		});

		// ============================================================
		// End Accordion custom images.
		// ============================================================



		// ============================================================
		// Bootstrap column adjustments.
		// ============================================================

		$('.bg-black-gradient .field__items .col-12')
			.addClass('col-lg');

		$('.promotion-box .col-lg-auto')
			.removeClass('col-lg-auto')
			.addClass('col-lg');

		// ============================================================
		// End Bootstrap column adjustments.
		// ============================================================



		// ============================================================
		// Scroll Back To Top button.
		// ============================================================

		const mybutton = document.getElementById('btn-back-to-top');

		if (mybutton) {

			// When the user scrolls down 20px from the top
			// of the document, show the button.
			window.addEventListener('scroll', scrollFunction);

			function scrollFunction() {

				if (
					document.body.scrollTop > 20 ||
					document.documentElement.scrollTop > 20
				) {
					mybutton.style.display = 'block';
				}
				else {
					mybutton.style.display = 'none';
				}

			}

			// When the user clicks on the button,
			// scroll to the top of the document.
			mybutton.addEventListener('click', backToTop);

			function backToTop() {
				document.body.scrollTop = 0;
				document.documentElement.scrollTop = 0;
			}

			// Run once on page load.
			scrollFunction();
		}

		// ============================================================
		// End Scroll Back To Top button.
		// ============================================================



		// ============================================================
		// Start of mimosanetworks Zendesk Widget script.
		// ============================================================

		function toggleModal() {
			$('.c-mimosa-modal--overlay').toggleClass('visible');
			$('.c-mimosa-modal').toggleClass('visible');
		}

		$('a[href="#modal"]').on('click', toggleModal);
		$('.c-mimosa-modal--overlay').on('click', toggleModal);
		$('.c-mimosa-modal__close-button').on('click', toggleModal);


		// Only run Zendesk code if $zopim is available.
		if (typeof $zopim !== 'undefined') {

			$zopim(function () {

				let chatOpen = false;

				$zopim.livechat.cookieLaw.comply();
				$zopim.livechat.cookieLaw.setDefaultImplicitConsent();

				$zopim.livechat.departments.setVisitorDepartment('US Sales');

				$zopim.livechat.theme.setColor('#3597e7');

				$zopim.livechat.setGreetings({
					disabled: 'Chat with us',
				});

				$("a[href='#openchat']").on('click', function () {

					$zopim.livechat.departments.setVisitorDepartment('Support');

					if (chatOpen) {

						$zopim.livechat.hideAll();
						chatOpen = false;

					}
					else {

						$zopim.livechat.window.show();
						chatOpen = true;

					}

				});

			});

		}

		// ============================================================
		// End of mimosanetworks Zendesk Widget script.
		// ============================================================


	});

})(jQuery, Drupal);